export default __webpack_public_path__ + "feeder.png?d2cb5f4ff8933ae82c0325eed79c3f74";